import React from 'react';
import styled, { css } from 'styled-components';

import breakpoints from '../../../vars/breakpoints';
import colors from '../../../vars/colors';

export const ItemWrapper = styled.div`
    font-size: 45px;
    font-family: 'OneDotCd', sans-serif;
    font-weight: bold;        
    justify-content: flex-start;
    margin-bottom: 20px;
    text-transform: uppercase;
    @media (max-width: ${breakpoints['bp-mobile']}) {
        font-size: 35px;
    }
    .number {
        color: ${colors['lipstick']};
        display: inline-block;
        margin-right: 20px;
        @media (max-width: ${breakpoints['bp-mobile']}) {
            display: block;
            margin-right: 0;
        }
    }
    .label {
        color: ${colors['peacock-blue']};
        display: inline-block;           
    }
`;

export const Title = styled.div`
    display: inline-block;
    font-family: 'OneDot';
    font-size: 25px;
    font-weight: bold;
    line-height: 1.4;
    letter-spacing: 3px;
    text-align: center;
    text-transform: uppercase;
    color: ${colors['peacock-blue']};
    border-bottom: solid 15px ${colors['white-two']};
    margin-bottom: 20px;
`;


// WEBPACK FOOTER //
// ./src/components/modules/ItemizedList/styled-components.js